import clsx from 'clsx'
import $form from '@tandem/ui/form.css'

export interface SelectInputProps {
  field: any
  disabled?: boolean
  options: Array<{ value: string | number; label: string }>
  readOnly?: boolean
  showEmpty?: boolean
  onValueChange?: (value: string) => void
}

export default function SelectInput({
  field,
  disabled,
  readOnly,
  options,
  showEmpty = true,
  onValueChange,
}: SelectInputProps) {
  let selectedOption = options.find(opt => opt.value === field.state.value)
  return (
    <select
      value={field.state.value ?? ''}
      onChange={(e) => {
        field.handleChange(e.target.value || undefined)
        onValueChange?.(e.target.value)
      }}
      onBlur={field.handleBlur}
      disabled={disabled || readOnly}
      class={clsx({
        [$form.placeholder]: !field.state.value,
        [$form.error]: !field.state.meta.isValid && field.state.meta.isTouched,
        [$form.readOnly]: readOnly
      })}
      title={selectedOption?.label}
    >
      {showEmpty && <option value='' />}
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  )
}
